import React, { useState } from 'react';
import { Check, Truck } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export const Pricing = () => {
  const {
    t
  } = useLanguage();
  const [selectedPackage, setSelectedPackage] = useState('family');
  const packages = [{
    id: 'family',
    header: t('pricing.buyGetFree'),
    discount: t('pricing.save55'),
    badge: t('pricing.bestSeller'),
    title: t('pricing.familyPack'),
    subtitle: `4x ${t('pricing.jumpBall')}`,
    quantity: `4x ${t('pricing.jumpBall')}`,
    price: '$44.97',
    pricePerUnit: t('pricing.each'),
    originalPrice: '$99.95',
    originalPerUnit: t('pricing.each'),
    total: `${t('pricing.total')}: $179.88`,
    features: [t('pricing.feature1'), t('pricing.feature2'), t('pricing.feature3'), t('pricing.feature4')],
    sellOutRisk: t('pricing.high'),
    freeShipping: true,
    discountPercent: '55%',
    popularity: t('pricing.bestSeller'),
    purchaseUrl: 'https://knovastore.com/cart/47931982774491:4'
  }, {
    id: 'duo',
    header: `Buy 2 ${t('pricing.jumpBall')}`,
    discount: 'Save 40%',
    badge: null,
    title: t('pricing.duoPack'),
    subtitle: `2x ${t('pricing.jumpBall')}`,
    quantity: `2x ${t('pricing.jumpBall')}`,
    price: '$59.95',
    pricePerUnit: t('pricing.each'),
    originalPrice: '$99.95',
    originalPerUnit: t('pricing.each'),
    total: `${t('pricing.total')}: $119.90`,
    features: [t('pricing.feature1'), t('pricing.feature2'), t('pricing.feature3'), t('pricing.feature4')],
    sellOutRisk: t('pricing.high'),
    freeShipping: true,
    discountPercent: '40%',
    popularity: 'Popular',
    purchaseUrl: 'https://knovastore.com/cart/47931982774491:2'
  }, {
    id: 'solo',
    header: `Buy 1 ${t('pricing.jumpBall')}`,
    discount: 'Save 30%',
    badge: null,
    title: t('pricing.soloPack'),
    subtitle: `1x ${t('pricing.jumpBall')}`,
    quantity: `1x ${t('pricing.jumpBall')}`,
    price: '$69.95',
    pricePerUnit: '',
    originalPrice: '$99.95',
    originalPerUnit: '',
    total: '',
    features: [t('pricing.feature1'), t('pricing.feature2'), t('pricing.feature3'), t('pricing.feature4')],
    sellOutRisk: t('pricing.high'),
    freeShipping: true,
    discountPercent: '30%',
    popularity: 'Moderate',
    purchaseUrl: 'https://knovastore.com/cart/47931982774491:1'
  }];
  const selectedPackageData = packages.find(pkg => pkg.id === selectedPackage);
  return <section className="py-8 md:py-16 bg-gray-50" data-id="element-162">
      <div className="container mx-auto px-3 md:px-8" data-id="element-163">
        {/* Desktop Layout */}
        <div className="hidden md:block space-y-4 md:space-y-6" data-id="element-164">
          {packages.map(pkg => <div key={pkg.id} className="bg-white rounded-lg shadow-lg overflow-hidden" data-id="element-165">
              <div className="bg-gradient-to-r from-blue-900 to-blue-700 text-white px-3 md:px-6 py-2 md:py-4 flex flex-col md:flex-row items-start md:items-center justify-between gap-2 md:gap-0" data-id="element-166">
                <div className="flex flex-wrap items-center gap-2 md:gap-4" data-id="element-167">
                  <h3 className="text-lg md:text-2xl font-bold" data-id="element-168">
                    {pkg.header}
                  </h3>
                  <span className="bg-green-500 text-white px-2 md:px-3 py-0.5 md:py-1 rounded text-xs md:text-sm font-bold" data-id="element-169">
                    {pkg.discount}
                  </span>
                  {pkg.badge && <span className="bg-orange-500 text-white px-2 md:px-3 py-0.5 md:py-1 rounded text-xs md:text-sm font-bold" data-id="element-170">
                      {pkg.badge}
                    </span>}
                </div>
                <div className="flex items-center gap-1 md:gap-2" data-id="element-171">
                  <Truck size={16} className="md:w-5 md:h-5" data-id="element-172" />
                  <span className="text-xs md:text-base font-bold" data-id="element-173">
                    {t('pricing.freeShipping')}
                  </span>
                </div>
              </div>
              <div className="bg-gradient-to-br from-yellow-50 to-orange-50 p-3 md:p-6" data-id="element-174">
                <div className="flex flex-col md:flex-row items-center gap-4 md:gap-8" data-id="element-175">
                  <div className="flex-shrink-0" data-id="element-176">
                    <button onClick={() => setSelectedPackage(pkg.id)} className={`w-10 h-10 md:w-12 md:h-12 rounded border-4 flex items-center justify-center transition ${selectedPackage === pkg.id ? 'bg-blue-600 border-blue-600' : 'bg-white border-gray-300'}`} data-id="element-177">
                      {selectedPackage === pkg.id && <Check className="text-white" size={24} data-id="element-178" />}
                    </button>
                  </div>
                  <div className="flex-shrink-0" data-id="element-179">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pquVSY7rnNWwdMfXsvpfr2/WhatsApp_Image_2025-11-14_at_16.10.20.jpg" alt="BranRok Jump Ball" className="w-32 h-32 md:w-48 md:h-48 object-contain" data-id="element-180" />
                  </div>
                  <div className="flex-1 w-full" data-id="element-181">
                    <h4 className="text-2xl md:text-3xl font-bold text-navy-900 mb-1 md:mb-2" data-id="element-182">
                      {pkg.title}
                    </h4>
                    <p className="text-lg md:text-xl text-gray-700 mb-2 md:mb-4" data-id="element-183">
                      {pkg.subtitle}
                    </p>
                    <p className="text-sm md:text-base text-gray-600 mb-3 md:mb-4" data-id="element-184">
                      {t('pricing.sameProduct')}
                    </p>
                    <div className="mb-3 md:mb-4" data-id="element-185">
                      <div className="flex items-baseline gap-2" data-id="element-186">
                        <span className="text-3xl md:text-5xl font-bold text-navy-900" data-id="element-187">
                          {pkg.price}
                        </span>
                        <span className="text-base md:text-xl text-gray-600" data-id="element-188">
                          {pkg.pricePerUnit}
                        </span>
                      </div>
                      <div className="flex items-baseline gap-2" data-id="element-189">
                        <span className="text-base md:text-xl text-gray-500 line-through" data-id="element-190">
                          {t('pricing.orig')} {pkg.originalPrice}
                        </span>
                        <span className="text-sm md:text-base text-gray-500" data-id="element-191">
                          {pkg.originalPerUnit}
                        </span>
                      </div>
                      {pkg.total && <p className="text-base md:text-lg font-semibold text-navy-900 mt-2" data-id="element-192">
                          {pkg.total}
                        </p>}
                    </div>
                    <div className="bg-blue-900 text-white rounded-lg p-3 md:p-4 mb-3 md:mb-4" data-id="element-193">
                      <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-4" data-id="element-194">
                        {pkg.features.map((feature, index) => <div key={index} className="text-center" data-id="element-195">
                            <p className="text-xs md:text-sm" data-id="element-196">{feature}</p>
                          </div>)}
                      </div>
                    </div>
                  </div>
                  <div className="flex-shrink-0 w-full md:w-auto" data-id="element-197">
                    <button onClick={() => setSelectedPackage(pkg.id)} className={`px-6 md:px-8 py-3 md:py-4 rounded-lg font-bold text-base md:text-lg transition w-full md:min-w-[200px] ${selectedPackage === pkg.id ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700 hover:bg-gray-300'}`} data-id="element-198">
                      {selectedPackage === pkg.id ? t('pricing.selected') : t('pricing.selectPackage')}
                    </button>
                  </div>
                </div>
                <div className="mt-4 md:mt-6 pt-3 md:pt-4 border-t border-gray-300 flex flex-wrap items-center justify-between gap-2 md:gap-4 text-xs md:text-sm" data-id="element-199">
                  <div className="flex items-center gap-1 md:gap-2" data-id="element-200">
                    <span className="font-semibold" data-id="element-201">
                      {t('pricing.sellOutRisk')}:
                    </span>
                    <span className="text-red-600 font-bold" data-id="element-202">
                      {pkg.sellOutRisk}
                    </span>
                  </div>
                  <div className="text-green-600 font-bold" data-id="element-203">
                    {pkg.freeShipping && t('pricing.freeShipping')}
                  </div>
                  <div data-id="element-204">
                    <span className="font-semibold" data-id="element-205">
                      {t('pricing.discount')}:
                    </span>{' '}
                    {pkg.discountPercent}
                  </div>
                  <div className="flex items-center gap-1 md:gap-2" data-id="element-206">
                    <div className="flex" data-id="element-207">
                      {[...Array(5)].map((_, i) => <div key={i} className={`w-2 h-4 ${i < (pkg.popularity === t('pricing.bestSeller') ? 5 : pkg.popularity === 'Popular' ? 4 : 3) ? 'bg-gray-800' : 'bg-gray-300'}`} data-id="element-208"></div>)}
                    </div>
                    <span className="font-bold" data-id="element-209">{pkg.popularity}</span>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
        {/* Mobile Vertical Stack Layout */}
        <div className="md:hidden space-y-3" data-id="element-210">
          {packages.map(pkg => <div key={pkg.id} className="bg-white rounded-lg shadow-lg overflow-hidden" data-id="element-211">
              {/* Compact Header */}
              <div className="bg-gradient-to-r from-blue-900 to-blue-700 text-white px-3 py-2" data-id="element-212">
                <div className="flex items-center justify-between mb-1" data-id="element-213">
                  <h3 className="text-xs font-bold" data-id="element-214">{pkg.header}</h3>
                  <div className="flex items-center gap-1" data-id="element-215">
                    <Truck size={12} data-id="element-216" />
                    <span className="text-xs font-bold" data-id="element-217">
                      {t('pricing.freeShipping')}
                    </span>
                  </div>
                </div>
                <div className="flex gap-2" data-id="element-218">
                  <span className="bg-green-500 text-white px-2 py-0.5 rounded text-xs font-bold" data-id="element-219">
                    {pkg.discount}
                  </span>
                  {pkg.badge && <span className="bg-orange-500 text-white px-2 py-0.5 rounded text-xs font-bold" data-id="element-220">
                      {pkg.badge}
                    </span>}
                </div>
              </div>
              {/* Compact Content */}
              <div className="bg-gradient-to-br from-yellow-50 to-orange-50 p-3" data-id="element-221">
                <div className="flex items-start gap-2 mb-2" data-id="element-222">
                  {/* Checkbox */}
                  <button onClick={() => setSelectedPackage(pkg.id)} className={`w-6 h-6 rounded border-3 flex items-center justify-center transition flex-shrink-0 ${selectedPackage === pkg.id ? 'bg-blue-600 border-blue-600' : 'bg-white border-gray-300'}`} data-id="element-223">
                    {selectedPackage === pkg.id && <Check className="text-white" size={14} data-id="element-224" />}
                  </button>
                  {/* Image */}
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pquVSY7rnNWwdMfXsvpfr2/WhatsApp_Image_2025-11-14_at_16.10.20.jpg" alt="BranRok Jump Ball" className="w-16 h-16 object-contain flex-shrink-0" data-id="element-225" />
                  {/* Title and Price */}
                  <div className="flex-1 min-w-0" data-id="element-226">
                    <h4 className="text-sm font-bold text-navy-900 leading-tight" data-id="element-227">
                      {pkg.title}
                    </h4>
                    <p className="text-xs text-gray-700 mb-1" data-id="element-228">{pkg.subtitle}</p>
                    <div className="flex items-baseline gap-1" data-id="element-229">
                      <span className="text-lg font-bold text-navy-900" data-id="element-230">
                        {pkg.price}
                      </span>
                      <span className="text-xs text-gray-600" data-id="element-231">
                        {pkg.pricePerUnit}
                      </span>
                    </div>
                    <div className="flex items-baseline gap-1" data-id="element-232">
                      <span className="text-xs text-gray-500 line-through" data-id="element-233">
                        {pkg.originalPrice}
                      </span>
                    </div>
                  </div>
                </div>
                {/* Features - Compact */}
                <div className="bg-blue-900 text-white rounded p-2 mb-2" data-id="element-234">
                  <div className="grid grid-cols-2 gap-1" data-id="element-235">
                    {pkg.features.map((feature, index) => <div key={index} className="text-center" data-id="element-236">
                        <p className="text-xs leading-tight" data-id="element-237">{feature}</p>
                      </div>)}
                  </div>
                </div>
                {/* Select Button - Compact */}
                <button onClick={() => setSelectedPackage(pkg.id)} className={`w-full px-3 py-2 rounded font-bold text-xs transition ${selectedPackage === pkg.id ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700'}`} data-id="element-238">
                  {selectedPackage === pkg.id ? t('pricing.selected') : t('pricing.selectPackage')}
                </button>
              </div>
            </div>)}
        </div>
        {/* CTA Button */}
        <div className="text-center mt-6 md:mt-10" data-id="element-239">
          <a href={selectedPackageData?.purchaseUrl || 'https://knovastore.com/cart/47931982774491:1'} className="inline-flex items-center justify-center bg-green-500 hover:bg-green-600 text-white font-bold py-3 md:py-4 px-6 md:px-10 rounded-lg text-base md:text-xl transition duration-300 shadow-lg" data-id="element-240">
            {t('pricing.cta')}
          </a>
        </div>
      </div>
    </section>;
};